import { Dialog, IconButton } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import CloseIcon from "@mui/icons-material/Close";
import DoneIcon from "@mui/icons-material/Done";
import { DialogContent, DialogTitle, Grid, Tooltip, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import jwt_decode from "jwt-decode";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import PurchaseDialog from "../../components/DialogBoxComponent/PurchaseDialog";
import Toast from "../../components/ToastContainer/CustomToast";
import { getVisitLimit } from "../../slices/Subscription/SubscriptionSlice";

const useStyles = makeStyles((theme) => ({
  doneIcon: {
    fontSize: "18px",
    color: "green",
    marginRight: theme.spacing(1),
  },
}));

function ListViewSubscription(props) {
  const classes = useStyles();
  const { t } = useTranslation();
  const [open, setOpen] = useState(props.open);
  const [featureNameList, setFeatureNameList] = useState(props.featureNameList);
  const planName = props.planName;
  const price = props.price;
  const id = props.id;
  const subscriptionType =
    props.subscriptionType === "Pay annual" ? "Yearly" : "Monthly";
  const [visitorCount, setVisitorCount] = useState(0);
  const [purchaseDialog, setPurchaseDialog] = useState(false);

  const [purchaseData, setPurchaseData] = useState({
    planName: props.planName,
    price: props.originalPrice,
    productId: props.productId,
  });
  const dispatch = useDispatch();
  var decoded_jwtToken = jwt_decode(
    localStorage.getItem(process.env.REACT_APP_ACCESS_TOKEN)
  );

  const handleClose = () => {
    setOpen(false);
  };

  const handlePurchase = () => {
    setPurchaseDialog(!purchaseDialog);
  };

  const handleOpen = () => {
    if (planName === "") {
      Toast(t("Please Enter Plan Name"), "error");
      return;
    }
    if (price === "") {
      Toast(t("Please Enter Price"), "error");
      return;
    }
    if (subscriptionType === "") {
      Toast(t("Please select Subscription Type"), "error");
      return;
    }

    dispatch(getVisitLimit(id))
      .unwrap()
      .then((data) => {
        if (data.code === "CVAI0000" && data.data.visitLimit !== undefined)
          setVisitorCount(data.data.visitLimit);
        else setVisitorCount(0);
      });

    setOpen(true);
  };

  const commonFeatures = [
    {
      key: 1,
      name: "SUBSCRIPTIONCOMMONFEATURES1"
    },
    {
      key: 2,
      name: "SUBSCRIPTIONCOMMONFEATURES2"
    },
    {
      key: 3,
      name: "SUBSCRIPTIONCOMMONFEATURES3"
    },
    {
      key: 4,
      name: "SUBSCRIPTIONCOMMONFEATURES4"
    },
    {
      key: 5,
      name: "SUBSCRIPTIONCOMMONFEATURES5"
    },
    {
      key: 6,
      name: "SUBSCRIPTIONCOMMONFEATURES6"
    },
    {
      key: 7,
      name: "SUBSCRIPTIONCOMMONFEATURES7"
    },
    {
      key: 8,
      name: "SUBSCRIPTIONCOMMONFEATURES8"
    },
    {
      key: 9,
      name: "SUBSCRIPTIONCOMMONFEATURES9"
    },
    {
      key: 10,
      name: "SUBSCRIPTIONCOMMONFEATURES10"
    },
    {
      key: 11,
      name: "SUBSCRIPTIONCOMMONFEATURES11"
    },
    {
      key: 12,
      name: "SUBSCRIPTIONCOMMONFEATURES12"
    },
    {
      key: 13,
      name: "SUBSCRIPTIONCOMMONFEATURES13"
    },
    {
      key: 14,
      name: "SUBSCRIPTIONCOMMONFEATURES14"
    },
    {
      key: 15,
      name: "SUBSCRIPTIONCOMMONFEATURES15"
    },
    {
      key: 16,
      name: "SUBSCRIPTIONCOMMONFEATURES16"
    },
    {
      key: 17,
      name: "SUBSCRIPTIONCOMMONFEATURES17"
    },
    {
      key: 18,
      name: "SUBSCRIPTIONCOMMONFEATURES18",
    }
  ]

  return (
    <>
      <div>
        {decoded_jwtToken.companyType === "PARTNER" ? (
          <Button
            size="small"
            sx={{
              "&:hover": {
                backgroundColor: "white",
              },
              fontSize: "14px",
              bottom: "120px",
              right: "-3px",
              height: "10px",
              mt: "10px",
            }}
            onClick={handleOpen}
          >
            {t("SUBSCRIPTIONVIEWFEATURES")}
          </Button>
        ) : (
          <Button
            size="small"
            sx={{
              "&:hover": {
                backgroundColor: "white",
              },
              fontSize: "14px",
              bottom: "110px",
              right: "-3px",
            }}
            onClick={handleOpen}
          >
            {t("SUBSCRIPTIONVIEWFEATURES")}
          </Button>
        )}

        {decoded_jwtToken.companyType === "PARTNER" ? (
          <Button
            size="small"
            sx={{
              "&:hover": {
                backgroundColor: "#F2824C",
              },
              fontSize: "14px",
              bottom: "140px",
              right: "-3px",
              height: "10px",
              ml: "40px",
              mt: "20px",
              backgroundColor: "#F2824C",
              color: "white",
              borderRadius: "40px !important",
            }}
            onClick={handlePurchase}
          >
            {t("SUBSCRIPTIONPURCHASE")}
          </Button>
        ) : (
          ""
        )}
      </div>
      <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth
        disableBackdropClick
        disableEscapeKeyDown
        BackdropProps={{
          style: {
            backdropFilter: "blur(5px)",
          },
        }}>
        <DialogTitle style={{ padding: "16px 24px", position: "relative" }}>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            style={{
              position: "absolute",
              right: 8,
              top: 8,
              color: "gray",
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent style={{ maxHeight: "500px", overflowY: "auto", padding: "24px" }}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={4} style={{ marginTop: "22%" }}>
              {planName && (
                <Grid item xs={12}>
                  <Tooltip title={planName} placement="bottom-start">
                    <Typography
                      variant="h3"
                      fontWeight="bold"
                      gutterBottom
                      color="black"
                      style={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        textAlign: "center",
                      }}
                    >
                      {planName}
                    </Typography>
                  </Tooltip>
                </Grid>
              )}
              {price && (
                <Grid item xs={12}>
                  <Typography
                    variant="h4"
                    className="xxb"
                    style={{
                      textAlign: "center",
                    }}
                  >
                    {price}
                  </Typography>
                </Grid>
              )}
              {subscriptionType && (
                <Grid item xs={12}>
                  <Typography
                    variant="subtitle1"
                    color="textSecondary"
                    style={{
                      textAlign: "center",
                    }}
                  >
                    {subscriptionType === "Monthly" ? t("MONTHLY") : t("YEARLY_UPPER_CASE")}
                  </Typography>
                </Grid>
              )}
              {visitorCount ? (
                <Grid item xs={12}>
                  <Typography
                    variant="subtitle1"
                    className="ppm"
                    style={{
                      textAlign: "center",
                    }}
                  >
                    {t("SUBSCRIPTIONVISITORCOUNT") + visitorCount}
                  </Typography>
                </Grid>
              ) : ""}
            </Grid>

            <Grid item xs={12} sm={4}>
              <Typography variant="h6" textAlign="center" gutterBottom style={{
                fontWeight: "bold",
                color: "black",
                opacity: 0.8,
                paddingRight: "125px"
              }}>
                {t("SUBSCRIPTIONCOMMONFEATURES")}
              </Typography>
              {commonFeatures.map((feature, index) => (
                <div key={index} style={{ display: "flex", alignItems: "center", marginBottom: "8px" }}>
                  <DoneIcon className={classes.doneIcon} />
                  <Tooltip title={t(feature.name)}>
                    <Typography style={{
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}>{t(feature.name)}</Typography>
                  </Tooltip>
                </div>
              ))}
            </Grid>

            <Grid item xs={12} sm={4}>
              <Typography variant="h6" textAlign="center" gutterBottom style={{
                fontWeight: "bold",
                color: "black",
                opacity: 0.8,
                paddingRight: "112px"
              }}>
                {t("SUBSCRIPTIONFEATURES")}
              </Typography>
              {featureNameList.map((feature, index) => (
                <div key={index} style={{ display: "flex", alignItems: "center", marginBottom: "8px" }}>
                  <DoneIcon className={classes.doneIcon} />
                  <Tooltip title={t(feature.name)}>
                    <Typography style={{
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}> {t(feature.name)}</Typography>
                  </Tooltip>
                </div>
              ))}
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>



      {purchaseDialog && (
        <PurchaseDialog
          open={purchaseDialog}
          data={purchaseData}
          purchasePlanDialog={props.purchasePlanDialog}
          handlePurchasedPlan={props.handlePurchasedPlan}
          subscriptionId={props.id}
          yearlyPlan={props.yearlyPlan}
          handleClose={() => {
            setPurchaseDialog(false);
          }}
        />
      )
      }
    </>
  );
}

export default ListViewSubscription;
